import { useContext } from 'react';
import { SelectedNodesContext } from '../contexts/SelectedNodesContext';

export function useSelectedFilterItems() {
  const ctx = useContext(SelectedNodesContext);
  if (!ctx)
    throw new Error(
      'useSelectedNodes must be used within SelectedNodesProvider'
    );
  return ctx;
}
